import { Any } from "../types/Any";
import {
  KindKey,
  CustomType,
  TypeKey,
  UnionType,
  UnionCase,
  UnionValues,
} from "../symbols";

export const show = o => {
  if (o == null) {
    return "Null";
  }

  if (o === Any) {
    return "Any";
  }

  if (typeof o === "string") {
    return `"${o}"`;
  }

  if (typeof o === "function") {
    return "function () {}";
  }

  if (o[KindKey] === CustomType) {
    const str = Object.keys(o)
      .reduce(
        (acc, key) =>
          key === KindKey || key === TypeKey
            ? acc
            : acc.concat(`${key}: ${show(o[key])}`),
        [],
      )
      .join(", ");
    return `${o[TypeKey]}({ ${str} })`;
  }

  if (o[KindKey] === UnionType) {
    if (o[UnionCase]) {
      return `${o[TypeKey]}.${o[UnionCase]}(${o[UnionValues].map(show).join(
        ", ",
      )})`;
    } else {
      return `${o[TypeKey]}`;
    }
  }

  if (Array.isArray(o)) {
    return `[ ${o.map(show).join(", ")} ]`;
  }

  if (o.constructor === Object) {
    return `{ ${Object.keys(o)
      .map(key => `${key}: ${show(o[key])}`)
      .join(", ")} }`;
  }

  return o.toString();
};
